import React, { useContext, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { CreationToolsWelcomeContext } from '../context'

const Dim = styled.div`
    background: rgba(0, 0, 0, 0.7);
    height: 100%;
    left: 0;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: opacity 0.2s ease-in;
    width: 100%;
`

const CreationToolsDropzone = () => {
    const { isDraggingFile, setIsDraggingFile } = useContext(CreationToolsWelcomeContext)
    const dragTimeoutRef = useRef<number>(0)

    const onDragEnter = (e: DragEvent) => {
        // prevent the browser from opening the file when dropping outside a file input
        if ((e.target as HTMLInputElement).type !== 'file') {
            e.preventDefault()
        }
        clearTimeout(dragTimeoutRef.current)
        setIsDraggingFile(true)
    }

    const onDragLeave = (e: DragEvent) => {
        if ((e.target as HTMLInputElement).type !== 'file') {
            e.preventDefault()
        }
        dragTimeoutRef.current = setTimeout(() => {
            setIsDraggingFile(false)
        }, 300)
    }

    useEffect(() => {
        if (window) {
            window.addEventListener('dragover', onDragEnter)
            window.addEventListener('dragenter', onDragEnter)
            window.addEventListener('dragleave', onDragLeave)
            window.addEventListener('dragend', onDragLeave)
            window.addEventListener('drop', onDragLeave)
        }

        return () => {
            clearTimeout(dragTimeoutRef.current)
            if (window) {
                window.removeEventListener('dragover', onDragEnter)
                window.removeEventListener('dragenter', onDragEnter)
                window.removeEventListener('dragleave', onDragLeave)
                window.removeEventListener('dragend', onDragLeave)
                window.removeEventListener('drop', onDragLeave)
            }
        }
    }, [])

    return <Dim style={{ opacity: isDraggingFile ? 1 : 0 }} />
}

export default CreationToolsDropzone
